import { AdDetailsState } from '@gumtree/shared/src/model/ad-details.model';
import { AD } from '@gumtree/shared/src/model/generic.model';
import { L1Category } from '@gumtree/shared/src/types/client-data';
import {
    getL1CategoryIdBySeoName,
    getL2CategoryIdBySeoName,
} from '@gumtree/shared/src/util/category-mapping';

export type State = AdDetailsState;

const initialState: State = {
    address: '',
    categoryName: '',
    attributes: [],
    allAttributes: [],
    description: [],
    logoUrl: '',
    id: -1,
    price: '',
    priceInPounds: undefined,
    seoPrice: undefined,
    title: '',
    token: '',
    postingSince: '',
    vhcData: { checked: false, extended: false },
    vatInfo: '',
    vatNumber: '',
    l1Category: getL1CategoryIdBySeoName('for-sale'),
    l1CategorySeoName: '' as L1Category,
    leafCategoryId: 0,
    l2CategoryId: getL2CategoryIdBySeoName('miscellaneous-goods'),
    seoL1Category: '',
    seoL2Category: '',
    sellerOtherAds: '',
    showLegalDisclaimer: false,
    pro: false,
    containsCallTrackingFeature: false,
    sellerType: null,
    subArea: '',
    isCurrentUserSeller: false,
    postedDate: 0,
    isFromMotorsFeed: false,
    currentPageUrl: '',
    scoreAndReviews: {
        average: 0,
        total: 0,
        topTips: '',
        bottomTips: '',
        type: '',
    },
    featured: false,
    standout: false,
    urgent: false,
    bumpup: false,
};

export const UPDATE_AD_DETAILS = 'UPDATE_AD_DETAILS';

export const updateAdDetails: AD<typeof UPDATE_AD_DETAILS, Partial<State>> = (payload) => ({
    type: UPDATE_AD_DETAILS,
    payload,
});

export default (state: State = initialState, action): State =>
    action.type === UPDATE_AD_DETAILS ? { ...state, ...action.payload } : state;
